<div class="modal-header">
  <h4 class="modal-title">{{ header }}</h4>
</div>

<div class="modal-body">
  <span id="content">{{ message }}</span>
</div>

<div class="modal-footer">
  <button class="btn btn-outline-primary" *ngIf="isShow" (click)="later()">
    Later
  </button>
  <button class="btn btn-primary" *ngIf="isAdmin" (click)="update()">
    {{ buttonText }}
  </button>
  <button class="btn btn-primary" *ngIf="!isAdmin" (click)="update()">
    Ok
  </button>
</div>
